module.exports = __webpack_public_path__ + "media/images/view-7a209af1aba9b88bc2bf6e85feb5c63b.gif";